import { observer } from '@rehaje/reactive-react'
import { createElement, Fragment, Suspense } from 'react'
import * as RouterDOM from 'react-router-dom'

import type { PagePluginProps } from './plugin'
import type { PageNode } from './TypedNode'
import type { PageModel, RouteState } from './ViewModel'
import type { VC } from '@rehaje/react'

export interface PageComponentProps {
  model?: PageModel
  node: PageNode
  state?: RouteState
}

const useRouteState = () => {
  const inRouterContext = RouterDOM.useInRouterContext()
  if (!inRouterContext) return
  const location = RouterDOM.useLocation()
  const params = RouterDOM.useParams()
  const navigate = RouterDOM.useNavigate()
  const [urlSearchParams, setURLSearchParams] = RouterDOM.useSearchParams()
  return {
    location,
    navigate,
    params,
    setURLSearchParams,
    urlSearchParams
  }
}

export const createPageComponent = (
  props: PagePluginProps
): VC<PageNode, PageModel> => {
  const PageComponent = observer(
    ({ model, node, state }: PageComponentProps) => {
      model?.register(state)
      return createElement(
        Fragment,
        {},
        ...node.elements.map((child) => child.render())
      )
    }
  )
  return function Page({ model, node }) {
    return (
      <Suspense fallback={props.spinnerElement}>
        <PageComponent model={model} node={node} state={useRouteState()} />
      </Suspense>
    )
  }
}
